import fb1 from "./fb1.png";
import fb2 from "./fb2.png";
import fb3 from "./fb3.png";
import fb4 from "./fb4.png";
import fb5 from "./fb5.png";
import fb6 from "./fb6.png";
import fb7 from "./fb7.png";
import fb8 from "./fb8.png";
import fb9 from "./fb9.png";


const certificates = [fb1, fb2, fb3, fb4, fb5, fb6, fb7, fb8, fb9];
export default certificates;
